<template>
  <div>
    <p class='mb-5'>{{ 'recovery.new.description' | translate }}</p>
    <ReportOfSicknessCard :employee="this.employee" :reportOfSickness="reportOfSickness" class='mt-5 mb-4'/>

    <form-input-container
      title='Uw Invoer voor Volledig Herstel'
      text='De door u ingevoerde gegevens voor de volledig herstel melding.'>

      <table class='confirmation-table'>
        <tr>
          <td>{{ 'recovery.form.recovery-date' | translate }}</td>
          <td>{{ formatDate(recovery.recoveryDate) }}</td>
        </tr>
      </table>
    </form-input-container>

    <div style='float: right' class='mt-4'>
      <Button primary class='mr-3' @click="this.handlePreviousClick">
        {{ 'buttons.previous-step' | translate }}
      </Button>

       <Button positive @click="this.handleConfirmationClick" :disabled="!isValid || isCreateLoading">
        {{ isCreateLoading ? 'recovery.form.confirming-and-creating' : 'recovery.form.confirm-and-create' | translate }}
      </Button>
    </div>
  </div>
</template>

<script>
import NewRecoveryConstants from '@/views/constants/recovery-new';
import ReportsOfSickness from '@/resources/constants/reports-of-sickness';

import Helpers from '@/shared/helpers/functions';
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import ReportOfSicknessCard from '@/views/components/reports-of-sickness/ReportOfSicknessCard.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';

export default {
  name: 'NewRecoveryConfirmation',
  components: {
    ReportOfSicknessCard,
    FormInputContainer,
    Button
  },
  props: {
    reportOfSickness: Object,
    employee: Object
  },
  computed: {
    recovery () {
      return this.$store.getters.newRecovery;
    },
    isValid () {
      return this.$store.getters.newRecoveryRequiredFields.isValid();
    },
    isCreateLoading () {
      return this.$store.getters.isCreateRecoveryLoading;
    }
  },
  methods: {
    handlePreviousClick () {
      this.$store.dispatch(NewRecoveryConstants.Actions.Navigate.DO,
        NewRecoveryConstants.Views.NewRecoveryInputForm);
    },
    handleConfirmationClick () {
      this.$store.dispatch(ReportsOfSickness.Actions.Recovery.Create.START,
        { reportOfSickness: this.reportOfSickness, recovery: this.recovery });
    },
    formatDate (value) {
      return Helpers.Dates.formatDate(value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.confirmation-row {
  border-bottom: 1px solid $gray-lighten-1;

  &:first-child {
    border-top: 1px solid $gray-lighten-1;
  }

  &.no-border {
    border: 0;

    td {
      padding-bottom: 0px;
    }
  }
}

.question {
  color: $primary-lighten-1;
}

.answer {
  color: $primary;
  font-weight: 600;
  font-size: 1.1em;
  text-align: right;
}

table {
  border-collapse: collapse;
  width: 100%;
}

table > tr {
  vertical-align: top;
  padding: 10px 0px;
  border-bottom: 1px solid $gray;
}

td {
  padding: 15px 0px;

  &:first-child {
    padding-right: 20px;
  }
}
</style>
